module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-square-7c95861197532d1c3693e9015de58426.png";